import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { profileImageSelector, lastLoginTimeSelector, profileSelector } from '../../../selectors'
import './userDetail.css'
import UserImage from 'custom/assets/dashboard/dummy-user.png'
import {
  getRoleAccessDetailsSelector,
  getRoleAccessKeySelector,
  getUserDetailsSelector,
  loginDetailsSelector,
  profileImageDetailsSelector,
  getLanguageSelector,
} from '../../store/selectors/app.selector'
import { setRoleAccessKey } from '../../store/actions/app.actions'
import { useTranslation } from 'react-i18next'
import { DASHBOARD_HEADER_KEYS } from '../../utils/translation-constants'
import config from 'custom/config/environment'
import { setAppLanguage } from '../../store/actions/app.actions'
import i18next from 'i18next'
import { Radio } from 'antd'

export default function UserDetail() {
  const dispatch = useDispatch()
  const loginDetails = useSelector(loginDetailsSelector)
  const profile = useSelector(getUserDetailsSelector)
  const image = useSelector(profileImageDetailsSelector)
  const accessKey = useSelector(getRoleAccessKeySelector)
  const accessDetails = useSelector(getRoleAccessDetailsSelector)
  const { t } = useTranslation()
  const selectedLng = useSelector(getLanguageSelector)
  // const [imageData, setImageData] = useState('')
  // console.log(accessDetails)
  // console.log(accessKey)

  const metaAccess = {
    I: `${t(DASHBOARD_HEADER_KEYS.INITIATOR)}`,
    A: `${t(DASHBOARD_HEADER_KEYS.AUTHORIZER)}`,
    AA: `${t(DASHBOARD_HEADER_KEYS.AUTO_AUTHORIZER)}`,
    VR: `${t(DASHBOARD_HEADER_KEYS.VERIFIER)}`,
    VW: `${t(DASHBOARD_HEADER_KEYS.VIEWER)}`,
  }

  function formatTime(dt) {
    let hours = new Date(dt).getHours()
    let minutes = new Date(dt).getMinutes()
    const time = hours >= 12 ? 'pm' : 'am'
    hours %= 12
    hours = hours || 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? `0${minutes}` : minutes
    const strTime = `${hours}:${minutes} ${time}`
    return strTime
  }
  function formatDate(dt) {
    let d = new Date(dt).getDate()
    let s = 'th'
    switch (d) {
      case '01':
      case '11':
      case '21':
      case '31':
        s = 'st'
        break
      case '02':
      case '12':
      case '22':
        s = 'nd'
        break
      case '03':
      case '13':
      case '33':
        s = 'rd'
        break
    }
    let m = new Date(dt).toDateString().split(' ', 3)[1]
    let y = new Date(dt).getFullYear().toString().slice(2, 4)
    const strDate = `${d}${s} ${m}'${y}`
    return strDate
  }

  const handleRoleChange = useCallback((e) => {
    dispatch(setRoleAccessKey(e.target.value))
  }, [])

  const handleLanguage = useCallback((e) => {
    try {
      const { value } = e.target
      dispatch(setAppLanguage(value))
      i18next.changeLanguage(value)
    } catch (err) {}
  }, [])

  return (
    <React.Fragment>
      <div className='d-flex justify-content-between user-details'>
        <div className=''>
          <div className='d-inline-block mr-2'>
            {image !== null && (
              <img
                className='rounded-circle'
                src={`data:image/png;base64, ${image && (image.imageData || image)}`}
                alt='user image'
                height='40'
                width='40'
              />
            )}
            {image === null && (
              <img
                className='rounded-circle'
                src={UserImage}
                alt='user image'
                height='40'
                width='40'
              />
            )}
          </div>
          <div className='d-inline-block font-weight-600'>
            {t(DASHBOARD_HEADER_KEYS.HI)}, {profile?.firstName} {profile?.lastName}
          </div>
        </div>

        <div className='text-right login-text font-weight-600'>
          <div>{t(DASHBOARD_HEADER_KEYS.LAST_LOGIN)}</div>
          <div>
            {formatDate(loginDetails?.lastLoginTime)}
            <span className='ml-2'>{formatTime(loginDetails?.lastLoginTime)}</span>
          </div>
          <div></div>
          {config.LANGUAGE_SELECTION && (
            <div className='language-selection-dashboard'>
              <select onChange={handleLanguage} value={selectedLng} placeholder='Choose Language'>
                {config.LANGUAGE_LIST.map((option, index) => (
                  <option value={option} key={index}>
                    {option.toLocaleUpperCase()}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
      <div className=''>
        <Radio.Group value={accessKey}   onChange={handleRoleChange} optionType='button' buttonStyle='solid' size='middle'>
          {Object.keys(accessDetails).map((item, index) => (
            <Radio.Button key={index} value={item}>
              {metaAccess[item]}
            </Radio.Button>
          ))}
        </Radio.Group>
        {/* <select style={{width:200,height:30}} onChange={handleRoleChange} defaultValue={accessKey}>
          {Object.keys(accessDetails).map((item, index) => (
            <option key={index} value={item}>
              {metaAccess[item]}
            </option>
          ))}
        </select> */}
      </div>

      {/* <div className='font-weight-600 mt-4'>No more information available at the moment.</div> */}
    </React.Fragment>
  )
}
